export const operationTypes = {
    master:2,
    upgrade:3,
    visa:4,
    2: "ONBOARDING TC MASTER",
    3: "UPGRADE TC",
    4: "ONBOARDING TC VISA",
};